// Dashboard — Statistiche dedicate al popup on-site sul carrello (GET /stats → campi popup + funnel eventi).
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { api, Ic } from "../shared";
import { formatMoney } from "../i18n";
import StatsPopupFunnel from "./StatsPopupFunnel";

export default function StatsPopupPage({ shopId, currencyCode = "EUR" }) {
  const [s, setS] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation("stats");
  const eur = (n) => formatMoney(i18n.language, currencyCode, n);

  useEffect(() => {
    if (!shopId) return;
    api(`/stats/${shopId}`)
      .then((d) => {
        setS(d);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [shopId]);

  if (loading) {
    return (
      <div className="empty">
        <div className="empty-icon-svg" aria-hidden>
          {Ic.loader}
        </div>
        <div className="empty-title">{t("loading")}</div>
      </div>
    );
  }
  if (!s || s.error) return <div className="ch-info">{t("errorLoad")}</div>;

  return (
    <div>
      <p style={{ fontSize: 14, color: "#6b7280", margin: "0 0 16px", lineHeight: 1.55 }}>
        {t("popupPage.intro")}
      </p>

      <StatsPopupFunnel events={s.onsite_popup_events}>
        <div className="stat-card">
          <div className="stat-label">{t("kpi.popupCarts")}</div>
          <div className="stat-val accent">{String(s.onsite_popup_carts ?? 0)}</div>
          <div className="stat-sub up">{t("kpi.popupCartsSub", { amount: eur(s.onsite_popup_revenue) })}</div>
        </div>
      </StatsPopupFunnel>

      <p style={{ fontSize: 13, color: "#6b7280", margin: "16px 0 0", lineHeight: 1.55 }}>
        {t("kpiPopupFoot.part1")}
        <strong>{t("kpiPopupFoot.strong")}</strong>
        {t("kpiPopupFoot.part2")}
        <code style={{ fontSize: 12 }}>attribution_channel = onsite_popup</code>
        {t("kpiPopupFoot.part3")}
      </p>
    </div>
  );
}
